import { Component, OnInit } from '@angular/core';
import { MessageService, ConfirmationService } from 'primeng/api';
import { PitufoService } from 'src/app/services/pesos/pitufo';
import { Router, ActivatedRoute } from '@angular/router';
import { ImprimirMultipleService } from 'src/app/services/imprimirMultiples/imprimirMultipleService';
import { GenericService } from 'src/app/services/generic/generic.service';
import { FirmaRevisionService } from 'src/app/services/firma_revision/firma-revision.service';
import { getDocumento, rellenarMenUsuario } from 'src/app/config/procedimientos_registros';
import { environment } from 'src/environments/environment';
import { VariedadesService } from 'src/app/services/variedades/variedades';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-list-pesos',
  templateUrl: './list-pesos.component.html',
  styleUrls: ['./list-pesos.component.css'],
  providers:[PitufoService,ConfirmationService,ImprimirMultipleService]
})
export class ListPesosComponent implements OnInit {


public cols:any[]=[];
public pesos:any[]=[];
public mostrar:boolean=false;
public title = "ANEXO VII REGISTRO DE CONTROL DE PESOS PITUFO";
public mostrarPeso={
  id:""
};

public display:boolean=false;
public database = "PesoPitufo"
public databases="PesoPitufo";
public discriminadorCampo = "etiqueta_archivo";
public es:any=[];
public displayMultiple: any;
public showFields: boolean = false;
public showDuplicate: boolean = true;
public appName = environment.appName;

public variedadesArray: any[] = []
public auxPesos: any[] = []



  constructor(
    private pesosService:PitufoService,
    private genericService: GenericService,
    private router:Router,
    private route:ActivatedRoute,
    private confirmationService: ConfirmationService,
    private imprimirMultipleService:ImprimirMultipleService,
    private messageService:MessageService,
    private FirmaRevisionService: FirmaRevisionService,
    private variedadesService: VariedadesService

    ) { }

  ngOnInit() {

    if (this.appName === "tresfrut") {
      this.title = "CONTROL DE PROCESOS"
    }

    this.es = {
      firstDayOfWeek: 1,
      dayNames: [ "domingo","lunes","martes","miércoles","jueves","viernes","sábado" ],
      dayNamesShort: [ "dom","lun","mar","mié","jue","vie","sáb" ],
      dayNamesMin: [ "D","L","M","X","J","V","S" ],
      monthNames: [ "enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre" ],
      monthNamesShort: [ "ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic" ],
      today: 'Hoy',
      clear: 'Borrar'
  }
    this.columnasSimples();
   /*
   id`,
`maquina`,
`cliente`,
`variedad`,
`pesos`,
`fecha`,
`hora`,
`confeccion
    */
   this.listPesos();
  }

  columnasSimples() {
    this.cols = [
      { field: 'opciones', header: 'Opciones', tipo: 'opciones' },
      { field: 'revision', header: 'Revisión', tipo: 'revision' },
      { field: 'fecha', header: 'Fecha', tipo: 'fecha' },
      { field: 'variedad', header: 'Variedad' },
      { field: 'calidad', header: 'Calidad diferenciada' },
    ];
  }
  columnasTotales() {
    this.cols = [
      { field: 'opciones', header: 'Opciones', tipo: 'opciones' },
      { field: 'revision', header: 'Revisión', tipo: 'revision' },
      { field: 'fecha', header: 'Fecha', tipo: 'fecha' },
      { field: 'variedad', header: 'Variedad' },
      { field: 'calidad', header: 'Calidad diferenciada' },
      { field: 'confeccion', header: 'Tipo Confección' },
      { field: 'maquina', header: 'Máquina' },
      { field: 'pesos', header: 'Pesos' },
      { field: 'cliente', header: 'Cliente' },
      { field: 'responsable', header: 'responsable' },
      { field: 'observaciones', header: 'Observaciones' },
    ]
  }
  dayOfWeek(day){
    let diaSemana="";
   switch(day) {
       case 0:
       diaSemana="Domingo";
       break;
       case 1:
       diaSemana="Lunes";
       break;
       case 2:
       diaSemana="Martes";
       break;
       case 3:
       diaSemana="Miercoles";
       break;
       case 4:
       diaSemana="Jueves";
       break;
       case 5:
       diaSemana="Viernes";
       break;
       case 6:
       diaSemana="Sabado";
       break;
       default:

   }
   return diaSemana;
  }

  comprobarEtiqueta(value) {
    // console.log('value', value);

    if ( value == null || value == undefined ){
      return true;
    }
    if ( value.length <= 0 ) {
      return true;
    }
    return false;
  }

   filtrarFecha(event,dt,col){

    if(event==null||event==""||event==undefined||event=={}){
     dt.filter(null,'fecha', col.filterMatchMode);
    }else{
     let myfecha=new Date(event);
     let mes=(myfecha.getMonth()+1);
     let mesCorregido="";
     let dia=myfecha.getDate();
     let diaCorregido="";
     if(mes<10){
       mesCorregido="0"+mes;
     }else{
       mesCorregido=""+mes;
     }
     if(dia<10){
       diaCorregido="0"+dia;
     }else{
       diaCorregido=""+dia;
     }

     let segmentarFEcha=diaCorregido+"/"+(mesCorregido)+"/"+myfecha.getFullYear();

     dt.filter(segmentarFEcha,'fecha', col.filterMatchMode);
    }
  this.cambios(dt);
}
comprobarCalidad( data: any) {
  //console.log(data);

    let result = new Array();
    let myRespuesta = '';
  /* global_gap
  IGP
  prod_integrado
  residuo */
    if (data.global_gap !== null && data.global_gap !== undefined && data.global_gap.localeCompare('1') == 0 ) {
        result.push('Global gap')
    }
    if (data.IGP !== null && data.IGP !== undefined && data.IGP.localeCompare('1') == 0 ) {
        result.push('IGP')
    }
    if (data.prod_integrado !== null && data.prod_integrado !== undefined && data.prod_integrado.localeCompare('1') == 0 ) {
        result.push('Producción integrada')
    }
    if (data.residuo !== null && data.residuo !== undefined && data.residuo.localeCompare('1') == 0 ) {
        result.push('Residuo 0')
    }

    if (result.length == 0 ) {
      return myRespuesta;
    } else {
      return myRespuesta = result.toString();
    }
  }

listPesos() {

  this.getLists().subscribe({
    next: (data) => {
      this.variedadesArray = data

    this.genericService.getList(this.database).toPromise()
    .then( (resp: any) => {
      this.pesos = this.transformData(resp.productos)
      this.mostrar = true;
    }).catch( (error: any) => {
      console.log("error",error);
      this.mostrar = false;
    });
    }
  })

  // this.genericService.getList(this.database).toPromise()
  // .then( (resp: any) => {
  //   // console.log(resp);
  //   this.pesos = resp.productos;
  //   this.mostrar = true;
  // }).catch( (error: any) => {
  //   console.log("error",error);
  //   this.mostrar = false;
  // });

}

nuevaPeso(){
  this.router.navigate(['crear'],{relativeTo:this.route});
}

info(id){
// console.log('info',id);

this.mostrarPeso.id=id;
this.display = true;


}

listarCampos() {


  if (!this.showFields) {
    this.columnasTotales();
    this.showFields = true;


  } else {

    this.columnasSimples();
    this.showFields = false;


  }
}

update(id){
  this.router.navigate(['edit',id],{relativeTo:this.route});
}

delete(id){
  this.confirmationService.confirm({
    header:'Confirmación',
    acceptLabel:'Aceptar',
    rejectLabel:'Cancelar',
    message: 'Quieres eliminar este registro?',
    accept: () => {
      this.pesosService.deletePitufo(id).subscribe(resp=>{
        //console.log(resp);
        this.messageService.add({ severity: 'success', summary: 'Borrado correctamente', detail: `Registro ${this.database} borrado` });
        this.listPesos();
      },error=>{
        console.log("error",error);
      });

    }
});
}

closeWindow(event){
  this.display=false;
}

duplicate(transporte) {
  this.genericService.clone(transporte.id , this.databases).toPromise().then(data => {
    this.messageService.add({ severity: 'success', summary: `Duplicado correctamente`, detail: `Registro ${this.databases} duplicado` });
    this.listPesos();
  }).catch(error => {
    this.messageService.add({ severity: 'error', summary: `Duplicado erróneamente`, detail: `Error en registro ${this.databases}` });
    console.log('error', error);
  });


}

arreglarfecha(fecha){

  let arregloFecha=fecha.split("/");

  let myfecha ="";

 // console.log(myfecha);
  myfecha=arregloFecha[2]+"-"+arregloFecha[1]+"-"+arregloFecha[0];
  return myfecha;
}

public mydt:any;
closeWindowMultpile(event){
  this.consultar();
}

cambios(dt){

  this.mydt = dt;

}


consultar(event = null) {
  if ( event != null ) {
    if (event.filteredValue) {
      this.imprimirMultipleService.showProducts(event.filteredValue);
    if (this.displayMultiple) {
      this.displayMultiple = false;
    } else {
      this.displayMultiple=true;
    }
    if(this.mydt==null || this.mydt==undefined ||this.mydt==[]||this.mydt.length==0){

      //console.log(this.tiritas);

    }else if(this.mydt.filteredValue==null|| this.mydt==undefined){
      //console.log(this.tiritas);
    }else{
      //console.log(this.mydt.filteredValue);
    }
    } else {
      this.mydt = event;
      this.imprimirMultipleService.showProducts(event.value);
    if (this.displayMultiple) {
      this.displayMultiple = false;
    } else {
      this.displayMultiple=true;
    }
    if(this.mydt==null || this.mydt==undefined ||this.mydt==[]||this.mydt.length==0){



    }else if(this.mydt.filteredValue==null|| this.mydt==undefined){

    }else{
      //console.log(this.mydt.filteredValue);
    }
    }



  } else {
    this.imprimirMultipleService.showProducts(this.listadoProductos());
  if (this.displayMultiple) {
    this.displayMultiple = false;
  } else {
    this.displayMultiple=true;
  }
  if(this.mydt==null || this.mydt==undefined ||this.mydt==[]||this.mydt.length==0){

    //console.log(this.tiritas);

  }else if(this.mydt.filteredValue==null|| this.mydt==undefined){
    //console.log(this.tiritas);
  }else{
    //console.log(this.mydt.filteredValue);
  }
  }



}

listadoProductos(){
  if(this.mydt==null || this.mydt==undefined ||this.mydt==[]||this.mydt.length==0){
    return this.pesos;
    //console.log(this.tiritas);

  }else if(this.mydt.filteredValue==null|| this.mydt==undefined){
    //console.log(this.tiritas);
    return this.pesos;
  }else{
    return this.mydt.filteredValue;
    //console.log(this.mydt.filteredValue);
  }
}
changeValue(data) {

  try {
    if (!this.checkRevision(data.revision)) {
      console.log(data, this.database);
      let revision = JSON.parse(localStorage.getItem('calidad_user_tag_1'));
      console.log(revision);

      let firma = {
        database: this.database,
        revision: revision.name,
        id: data.id,
      }
      this.FirmaRevisionService.updateFirma(firma).toPromise()
        .then(resp => {
          console.log('firma', resp);

        }).catch(error => {
          console.log(' error', error);

        });
    } else {
      let firma = {
        database: this.database,
        revision: '',
        id: data.id,
      }
      this.FirmaRevisionService.updateFirma(firma).toPromise()
        .then(resp => {
          console.log('firma', resp);

        }).catch(error => {
          console.log(' error', error);

        });
    }
  } catch (error) {
    let firma = {
      database: this.database,
      revision: '',
      id: data.id,
    }
    this.FirmaRevisionService.updateFirma(firma).toPromise()
      .then(resp => {
        console.log('firma', resp);

      }).catch(error => {
        console.log(' error', error);

      });
  }


}
checkRevision(value) {
  try {
    if (value == null || value == undefined) {
      return false;
    } else {
      if ((value as string).length > 1) {
        return true;
      } else {
        return false;
      }

    }
  } catch (error) {
    return false;
  }

}

checkRole() {
  try {
    if ( localStorage.getItem('role').localeCompare('ROLE_ADMIN') == 0 ) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }

}

getLists(): Observable<any>{
  return this.variedadesService.listVariedad()
}

transformData(products: any[]): any[]{
  return products.map(product => {
    const peso = this.variedadesArray.find(variedad => variedad.id === product.variedad)
    return {
      ...product,
      variedad: peso ? peso.nombre : product.variedad
    }
  })
}


}


